import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Tabs,
  Tab,
  Divider,
  IconButton,
} from "@material-ui/core";
import * as React from "react";
import TabPanel from "../components/TabPanel";
import { TOOL_BAR_BUTTON_TYPES } from "./DashboardScreen";
import AddEmployeDialog from "../dialogs/AddEmployeDialog";
import AddInspectionDialog from "../dialogs/AddInspectionDialog";
import ViewInspectionDialog from "../dialogs/ViewInspectionDialog";
import { EmployeeService } from "../services/EmployeeService";
import { EventEmitter } from "../events/EventEmitter";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";
import { match } from "react-router-dom";
import { CompaniesService } from "../services/CompaniesService";
import LicenseIcon from "@material-ui/icons/Payment";
import AuthorisedIcon from "@material-ui/icons/EmojiTransportation";
import TableComponent from "../components/TableComponent";
import GenericDialog, { types } from "../dialogs/GenericDialog";
import SignedByDialog from "../dialogs/SignedByDialog";
import AssignDialog from "../dialogs/AssignDialog";
import EditIcon from "@material-ui/icons/Edit";
import ViewIcon from "@material-ui/icons/ViewCompact";
import DeleteIcon from "@material-ui/icons/Delete";
import {
  EMPLOYEE_COLUMNS,
  EQUIPMENT_COLUMNS,
  INSPECTION_COLUMNS,
  COMPLETED_COLUMNS,
  VISITORS_COLUMNS,
  TRACING_COLUMNS,
} from "../constants/tableColumns";
import AddEquipmentsDialog from "../dialogs/AddEquipmentsDialog";
import { EquipmentsService } from "../services/EquipmentsService";
import { InspectionService } from "../services/InspectionService";
import { ContactTracingService } from "../services/ContactTracingService";
import { ActionedService } from "../services/ActionedService";
import ListItemDialog from "../dialogs/ListItemDialog";
import BaseComponent from "../components/BaseComponent";
import { AssignTo } from "../model/ActionedInspectionModel";
import history from "../utils/history";
import {
  isEmpty,
  getMomentDate,
  getInspectionLabel,
  convertTextToTitleCase,
  INSPECTION_CAPTURE_TYPES,
} from "../constants/constants";
import { AssetsService } from "../services/AssetsService";
import { VisitorService } from "../services/VisitorService";
import AddVisitorDialog from "../dialogs/AddVisitorDialog";
import HasMutablePermission from "../auth/HasMutablePermission";
import { AppContext, AuthConsumer } from "../routes/AuthContext";
import ContactsDialog from "../dialogs/ContactsDialog";
import PublishIcon from "@material-ui/icons/Publish";
import { DropzoneDialog } from "material-ui-dropzone";
import LoadingComponents from "../components/LoadingComponents";
import FileManagmentDialog from "../dialogs/FileManagmentDialog";
import SelectInspectionCaptureTypeDialog from "../dialogs/SelectInspectionCaptureTypeDialog";
import AddWorkFlowInspectionDialog from "../dialogs/AddWorkFlowInspectionDialog";
import ViewWorkFlowInspectionDialog from "../dialogs/ViewWorkFlowInspectionDialog";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    button: {
      margin: theme.spacing(1),
      width: "20%",
      height: 48,
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
    margin: {
      margin: theme.spacing(1),
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
  });
export const TAB_PANELS_TYPES = {
  EMPLOYEES: "EMPLOYEES",
  INSPECTIONS: "INSPECTIONS",
  EQUIPMENTS: "EQUIPMENTS",
  COMPLETED: "COMPLETED",
  TRACING: "TRACING",
  VISITORS: "VISITORS",
  NORMAL: "NORMAL",
};
const createEquipmentsUniqueIdentifier = function (row: any, index: any) {
  return `${row._id}`;
};
const createEquipmentsData = function (row: any) {
  return {
    name: row.name,
    number: row.number,
    size: row.size,
    type: row.type,
  };
};
const createVisitorsUniqueIdentifier = function (row: any, index: any) {
  return `${row._id}`;
};
const createVisitorsActionsData = function (row: any) {
  return {
    fullName: row.fullName ? row.fullName : "",
    identityNumber: row.identityNumber ? row.identityNumber : "",
    passportNumber: row.passportNumber ? row.passportNumber : "",
    department:
      row.department && row.department.title ? row.department.title : "",
    companyName: row.companyName ? row.companyName : "",
    actions: "Actions",
  };
};
interface DetailParams {
  companyId: string;
}
interface Props extends WithStyles<typeof styles> {
  company?: any;
  updateToolBarButton?: any;
  match?: match<DetailParams>;
  location?: any;
}

class CompanyScreen extends React.Component<Props, any> {
  state = {
    value: 0,
    openAddEmployeesDialog: false,
    openEditEmployeesDialog: false,
    openAddInspectionDialog: false,
    openSelectInspectionCaptureType: false,
    openAddWorkflowInspection: false,
    openViewInspectionDialog: false,
    openViewWorkflowInspectionDialog: false,
    openEmployeeLoginDetailsDialog: false,
    openAddEquipmentsDialog: false,
    openAddVisitorsDialog: false,
    company: {
      inspectionCategories: [],
      inspectionTypes: [],
      inspectionFrequencies: [],
      workflows: false,
    },
    assets: [],
    profileData: {},
    recentlyAddedEmployee: { fullName: "", employeeNumber: "", password: "" },
    employees: [],
    equipments: [],
    inspections: [],
    visitors: [],
    actionedInspections: [],
    allLegends: [],
    completedActions: [],
    toolBarData: { title: "", type: "", callBack: null },
    pageTitle: "",
    showApprovals: false,
    approvalRowSelected: [],

    showContacts: false,
    contactsRowSelected: [],

    showAssignDialog: false,
    showLicensesDialog: false,
    showActionedInspectionsDialog: false,
    showAuthorizedEquipmentsDialog: false,
    licenseRowSelected: { licenseDetails: [] },
    actionedInspectionRowSelected: {},
    authorizedEquipmentRowSelected: { licenseDetails: [] },
    assignRowSelected: {},
    completedRowSelected: [],
    contacts: [],
    tabPanels: new Array<any>(),
    editVisitorsData: { fullName: "" },
    editEmployeeData: { passportDocument: false, passportNumber: "" },
    editInspectionData: {},
    editEquipmentData: { number: "" },
    openConfirmationDialog: false,
    deletingObject: { row: { fullName: "", name: "" }, tabType: "" },
    showConfirmationDialog: false,
    actionedInspectionDeletionObj: { _id: "", inspection: { name: "" } },
    openDropZoneDialog: false,
    filesDropZoneFiles: [],
    deleteAll: false,
    isEmployeeLoading: false,

    openHelpDialog: false,
  };
  createEmployeeUniqueIdentifier = (row: any, index: any) => {
    return `${row._id}`;
  };
  createEmployeeData = (row: any, accessRules: any) => {
    let contextState = this.context;
    let user = contextState && contextState.user ? contextState.user : null;
    return {
      fullName: row.fullName,
      email: row.email ? row.email : "",
      employeeNumber: row.employeeNumber ? row.employeeNumber : "",
      position: row.position ? row.position : "",
      actionedInspections:
        user &&
        HasMutablePermission({
          role: user.role,
          data: user.role,
          accessRules: accessRules,
          perform: "actionedInspection:view",
        })
          ? {
              title: "Actioned Inspections",
              action: this.handleActionedInspections,
            }
          : null,
      licenseNumbers: {
        title: "License Datails",
        action: this.handleLicenses,
      },
      authorizeEquipments: {
        title: "Authorised Equipments",
        action: this.handleAuthorizedEquipments,
      },
      department:
        row.department && row.department.title ? row.department.title : "",
      section: row.section && row.section.title ? row.section.title : "",
      phone: row.phone ? row.phone : "",
    };
  };
  createInspectionsUniqueIdentifier = (row: any, index: any) => {
    return `${row._id}`;
  };
  createInspectionsData = (row: any) => {
    let inspectionType = getInspectionLabel(
      row.inspectionType,
      this.state.company.inspectionTypes
    );
    return {
      name: row.name,
      category: getInspectionLabel(row.category, inspectionType.categories)
        .label,
      inspectionType: inspectionType.label,
      frequency: getInspectionLabel(
        row.frequency,
        this.state.company && this.state.company.inspectionFrequencies
          ? this.state.company.inspectionFrequencies
          : []
      ).label,
      labels: row.workflows.length,
    };
  };
  createCompletedActionsUniqueIdentifier = (row: any, index: any) => {
    return `${row._id}`;
  };
  createCompletedActionsData = (row: any) => {
    let inspectionType = getInspectionLabel(
      row.inspection.inspectionType,
      this.state.company.inspectionTypes
    );
    let ownerPerson = row.assign.assignedTo;
    const { inspection } = row;
    let momentDate = getMomentDate(row.assign.completionDate);
    return {
      name: inspection.name,
      inspectionType: inspectionType.label,
      category: getInspectionLabel(
        row.inspection.category,
        inspectionType.categories
      ).label,
      frequency: convertTextToTitleCase(inspection.frequency),
      completedBy: ownerPerson.fullName,
      completedOn: momentDate.toString(),
      approvals: "Signed by",
      actions: "Actions",
    };
  };
  createTracingUniqueIdentifier = (row: any, index: any) => {
    let ownerPerson = row.assign.assignedTo;
    return `${index}-${ownerPerson.fullName}-${row.assign.completionDate}`;
  };
  createTracingActionsData = (row: any) => {
    let ownerPerson = row.assign.assignedTo;
    const { inspection } = row;
    let momentDate = getMomentDate(row.assign.completionDate);
    return {
      completedBy: ownerPerson.fullName,
      contactWith: inspection.formsItems.length,
      completionDate: momentDate.toString(),
      contacts: "Contacts",
    };
  };

  onEditRow = (row: any, tabType: any) => {
    switch (tabType) {
      case TAB_PANELS_TYPES.EMPLOYEES:
        return this.onEditEmployeesCalled(row);
      case TAB_PANELS_TYPES.INSPECTIONS:
        return this.onEditInspectionsCalled(row);
      case TAB_PANELS_TYPES.EQUIPMENTS:
        return this.onEditEquipmentsCalled(row);
      case TAB_PANELS_TYPES.COMPLETED:
        return this.onEditCompletedCalled(row);
      case TAB_PANELS_TYPES.VISITORS:
        return this.onEditVisitorCalled(row);
      default: {
        return null;
      }
    }
  };
  onViewRow = (row: any, tabType: any) => {
    switch (tabType) {
      case TAB_PANELS_TYPES.EMPLOYEES:
        return this.onViewMoreEmployeesCalled(row);
      case TAB_PANELS_TYPES.INSPECTIONS:
        return this.onViewMoreInspectionsCalled(row);
      case TAB_PANELS_TYPES.EQUIPMENTS:
        return this.onViewMoreEquipmentsCalled(row);
      case TAB_PANELS_TYPES.COMPLETED:
        return this.onViewMoreCompletedCalled(row);
      default: {
        return null;
      }
    }
  };
  onDeleteRow = (row: any, tabType: any) => {
    this.setState({
      deletingObject: { row: row, tabType: tabType },
      openConfirmationDialog: true,
    });
  };
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: true });
  };
  getCallBack = (selectedTabType: any) => {
    switch (selectedTabType) {
      case TOOL_BAR_BUTTON_TYPES.EMPLOYEE:
        return this.onAddEmployeesCalled;
      case TOOL_BAR_BUTTON_TYPES.INSPECTIONS:
        return this.onAddInspectionsCalled;
      case TOOL_BAR_BUTTON_TYPES.EQUIPMENTS:
        return this.onAddEquipmentsCalled;
      case TOOL_BAR_BUTTON_TYPES.VISITORS:
        return this.onAddVisitorsCalled;
      default: {
        return null;
      }
    }
  };
  dataActions = (tabType: any) => {
    return [
      {
        icon: <EditIcon fontSize="small" />,
        name: tabType,
        action: this.onEditRow,
      },
      {
        icon: <ViewIcon fontSize="small" />,
        name: tabType,
        action: this.onViewRow,
      },
      {
        icon: <DeleteIcon fontSize="small" />,
        name: tabType,
        action: this.onDeleteRow,
      },
    ];
  };
  handleChange = (event: any, newValue: any, user: any, accessRules: any) => {
    // let panel = this.state.tabPanels[newValue];
    let panels = this.state.tabPanels;
    let permittedPanels = new Array<any>();
    panels.map((mPanel: any) => {
      if (
        HasMutablePermission({
          role: user.role,
          accessRules: accessRules,
          perform: mPanel.perform,
          data: {},
        })
      ) {
        permittedPanels.push(mPanel);
      }
      return null;
    });
    let panel = permittedPanels[newValue];

    if (panel && panel.title) {
      let toolBarData = {
        title: panel.title,
        type: panel.type,
        callBack: this.getCallBack(panel.type),
        additionalToolBarData:
          panel.id === TAB_PANELS_TYPES.EMPLOYEES ||
          panel.id === TAB_PANELS_TYPES.COMPLETED
            ? {
                title: "Import",
                action: this.onImportCalled,
                icon: <PublishIcon />,
              }
            : null,
      };
      this.setState({
        value: newValue,
        toolBarData: toolBarData,
      });
    }
  };

  handleShowApprovals = (row: any) => {
    const { inspection } = row;
    let approvals = Array<AssignTo>();

    inspection.signotoriesItems.map((item: any) => {
      if (item.value) {
        approvals.push(item.value);
      }
      return null;
    });
    this.setState({
      showApprovals: true,
      approvalRowSelected: approvals,
    });
  };

  handleShowContacts = (row: any) => {
    const { inspection } = row;
    this.setState({
      showContacts: true,
      contactsRowSelected: inspection.formsItems,
    });
  };

  handleShowAssign = (row: any) => {
    this.setState({
      showAssignDialog: true,
      assignRowSelected: row,
    });
  };
  handleLicenses = (row: any) => {
    this.setState({
      showLicensesDialog: true,
      licenseRowSelected: row,
    });
  };
  handleActionedInspections = (row: any) => {
    this.setState(
      {
        deleteAll: false,
      },
      async () => {
        await this.getActionedInspectionByCompany(row);
      }
    );
  };
  handleAuthorizedEquipments = (row: any) => {
    this.setState({
      showAuthorizedEquipmentsDialog: true,
      authorizedEquipmentRowSelected: row,
    });
  };
  onImportCalled = () => {
    this.setState({
      openDropZoneDialog: true,
    });
  };
  onAddEmployeesCalled = () => {
    this.setState({ openAddEmployeesDialog: true, editData: {} });
  };
  onAddInspectionsCalled = () => {
    if (this.state.company && this.state.company.workflows) {
      this.setState({
        openSelectInspectionCaptureType: true,
        editInspectionData: {},
      });
    } else {
      this.setState({ openAddInspectionDialog: true, editInspectionData: {} });
    }
  };
  onAddEquipmentsCalled = () => {
    this.setState({ openAddEquipmentsDialog: true, editEquipmentData: {} });
  };
  onAddVisitorsCalled = () => {
    this.setState({ openAddVisitorsDialog: true, editVisitorData: {} });
  };

  onEditEmployeesCalled = (row: any) => {
    this.setState({
      editEmployeeData: row,
      openEditEmployeesDialog: true,
    });
  };
  onEditInspectionsCalled = (row: any) => {
    if (row.workflows && row.workflows.length > 0) {
      this.setState({
        editInspectionData: row,
        openAddWorkflowInspection: true,
      });
    } else {
      this.setState({
        editInspectionData: row,
        openAddInspectionDialog: true,
      });
    }
  };
  onEditEquipmentsCalled = (row: any) => {
    this.setState({
      editEquipmentData: row,
      openAddEquipmentsDialog: true,
    });
  };
  onEditToAssignCalled = (row: any) => {
    this.setState({
      editData: row,
    });
  };
  onEditCompletedCalled = (row: any) => {
    this.setState({
      editData: row,
    });
  };
  onEditVisitorCalled = (row: any) => {
    this.setState({
      editVisitorsData: row,
      openAddVisitorsDialog: true,
    });
  };
  deleteAllSelectedEmployees = (selectedList: any) => {
    let employeeService: EmployeeService = new EmployeeService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    employeeService.deleteAllSelectedEmployees(selectedList).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        if (resp.deleted) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.SUCCESS,
            show: true,
            message: "Deleted Successfully",
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.SUCCESS,
            show: true,
            message: "Deleted Successfully,partial",
          });
        }
        this.setState(
          {
            openConfirmationDialog: false,
            deletingObject: {},
          },
          () => {
            this.getEmployeesCompany(resp.companyId);
          }
        );
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };
  onDeleteEmployeesCalled = (row: any) => {
    let employeeService: EmployeeService = new EmployeeService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    employeeService.deleteEmployee(row).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.SUCCESS,
          show: true,
          message: "Deleted Successfully",
        });
        this.setState(
          {
            openConfirmationDialog: false,
            deletingObject: {},
          },
          () => {
            this.getEmployeesCompany(row.companyId);
          }
        );
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };
  deleteAllSelectedInspections = (selectedList: any) => {
    let inspectionService: InspectionService = new InspectionService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    inspectionService
      .deleteAllSelectedInspections(selectedList)
      .then((resp) => {
        EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
        if (resp && resp.success) {
          if (resp.deleted) {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.SUCCESS,
              show: true,
              message: "Deleted Successfully",
            });
          } else {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.SUCCESS,
              show: true,
              message: "Deleted Successfully,partial",
            });
          }
          this.setState(
            {
              openConfirmationDialog: false,
              deletingObject: {},
            },
            () => {
              this.getInspectionsByCompanyId(resp.companyId);
            }
          );
        } else if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        }
      });
  };
  onDeleteInspectionsCalled = (row: any) => {
    let inspectionService: InspectionService = new InspectionService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    inspectionService.deleteInspection(row).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.SUCCESS,
          show: true,
          message: "Deleted Successfully",
        });
        this.setState(
          {
            openConfirmationDialog: false,
            deletingObject: {},
          },
          () => {
            this.getInspectionsByCompanyId(row.companyId);
          }
        );
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };
  deleteAllSelectedEquipments = (selectedList: any) => {
    let equipmentService: EquipmentsService = new EquipmentsService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    equipmentService.deleteAllSelectedEquipments(selectedList).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        if (resp.deleted) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.SUCCESS,
            show: true,
            message: "Deleted Successfully",
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.SUCCESS,
            show: true,
            message: "Deleted Successfully,partial",
          });
        }
        this.setState(
          {
            openConfirmationDialog: false,
            deletingObject: {},
          },
          () => {
            this.getEquipmentsByCompanyId(resp.companyId);
          }
        );
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };
  onDeleteEquipmentsCalled = (row: any) => {
    let equipmentService: EquipmentsService = new EquipmentsService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    equipmentService.deleteEquipment(row).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.SUCCESS,
          show: true,
          message: "Deleted Successfully",
        });
        this.setState(
          {
            openConfirmationDialog: false,
            deletingObject: {},
          },
          () => {
            this.getEquipmentsByCompanyId(row.companyId);
          }
        );
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };
  deleteAllSelectedToAssign = (selectedList: any) => {};
  onDeleteToAssignCalled = (row: any) => {};
  deleteAllSelectedCompletedActionedInspections = (selectedList: any) => {
    let actionedService: ActionedService = new ActionedService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    actionedService
      .deleteAllSelectedCompletedInspection(selectedList)
      .then((resp) => {
        EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
        if (resp && resp.success) {
          if (resp.deleted) {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.SUCCESS,
              show: true,
              message: "Deleted Successfully",
            });
          } else {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.SUCCESS,
              show: true,
              message: "Deleted Successfully,partial",
            });
          }
          this.setState(
            {
              openConfirmationDialog: false,
              deletingObject: {},
            },
            () => {
              this.getCompletedActionedByCompanyId(resp.companyId);
            }
          );
        } else if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        }
      });
  };
  onDeleteCompletedCalled = (row: any) => {
    let actionedService: ActionedService = new ActionedService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    actionedService.deleteCompletedInspection(row).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.SUCCESS,
          show: true,
          message: "Deleted Successfully",
        });
        this.setState(
          {
            openConfirmationDialog: false,
            deletingObject: {},
          },
          () => {
            this.getCompletedActionedByCompanyId(row.companyId);
          }
        );
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };
  deleteAllSelectedVisitors = (selectedList: any) => {
    let visitorService: VisitorService = new VisitorService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    visitorService.deleteAllSelectedVisitors(selectedList).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        if (resp.deleted) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.SUCCESS,
            show: true,
            message: "Deleted Successfully",
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.SUCCESS,
            show: true,
            message: "Deleted Successfully,partial",
          });
        }
        this.setState(
          {
            openConfirmationDialog: false,
            deletingObject: {},
          },
          () => {
            this.getVisitorsCompany(resp.companyId);
          }
        );
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };
  onDeleteVisitorCalled = (row: any) => {
    let visitorService: VisitorService = new VisitorService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    visitorService.deleteVisitor(row).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.SUCCESS,
          show: true,
          message: "Deleted Successfully",
        });
        this.setState(
          {
            openConfirmationDialog: false,
            deletingObject: {},
          },
          () => {
            this.getVisitorsCompany(row.companyId);
          }
        );
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };
  onViewMoreEmployeesCalled = (row: any) => {};
  onViewToAssignCalled = (row: any) => {};
  onViewMoreCompletedCalled = (row: any) => {
    let actionedService: ActionedService = new ActionedService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    actionedService.getActionedById(row._id).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success && resp.actioned) {
        if (
          resp.actioned.inspection &&
          resp.actioned.inspection.workflows &&
          resp.actioned.inspection.workflows.length > 0
        ) {
          this.setState({
            openViewWorkflowInspectionDialog: true,
            completedRowSelected: resp.actioned,
          });
        } else {
          this.setState({
            openViewInspectionDialog: true,
            completedRowSelected: resp.actioned,
          });
        }
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };
  onViewMoreInspectionsCalled = (row: any) => {};
  onViewMoreEquipmentsCalled = (row: any) => {};
  componentDidMount = () => {
    let contextState = this.context;
    var user = contextState && contextState.user ? contextState.user : null;
    if (user) {
      const params = this.props.location.state;
      let panels = new Array<any>();

      panels.push({
        title: "Employees",
        perform: "company-employees:view",
        id: TAB_PANELS_TYPES.EMPLOYEES,
        type: TOOL_BAR_BUTTON_TYPES.EMPLOYEE,
      });

      panels.push({
        title: "Inspections",
        perform: "company-inspections:view",
        id: TAB_PANELS_TYPES.INSPECTIONS,
        type: TOOL_BAR_BUTTON_TYPES.INSPECTIONS,
      });
      panels.push({
        title: "Equipments",
        perform: "company-equipments:view",
        id: TAB_PANELS_TYPES.EQUIPMENTS,
        type: TOOL_BAR_BUTTON_TYPES.EQUIPMENTS,
      });
      panels.push({
        title: "Completed",
        perform: "company-completed:view",
        id: TAB_PANELS_TYPES.COMPLETED,
        type: TOOL_BAR_BUTTON_TYPES.COMPLETED,
      });
      panels.push({
        title: "Contact Tracing",
        perform: "company-tracing:view",
        id: TAB_PANELS_TYPES.TRACING,
        type: TOOL_BAR_BUTTON_TYPES.NORMAL,
      });
      panels.push({
        title: "Visitors",
        perform: "company-visitors:view",
        id: TAB_PANELS_TYPES.VISITORS,
        type: TOOL_BAR_BUTTON_TYPES.VISITORS,
      });
      if (params) {
        this.setState(
          {
            value: 0,
            profileData: user,
            tabPanels: panels,
          },
          () => {
            this.setToolBarData();
            this.getAssets();
            this.getCompany(params.companyId);
            this.getEmployeesCompany(params.companyId);
            this.getVisitorsCompany(params.companyId);
            this.getEquipmentsByCompanyId(params.companyId);
            this.getInspectionsByCompanyId(params.companyId);
            this.getCompletedActionedByCompanyId(params.companyId);
            this.getContactTracingByCompanyId(params.companyId);
          }
        );
      } else {
        // history.push({
        //   pathname: `/`
        // });
      }
    } else {
      history.push({
        pathname: `/login`,
      });
    }
  };

  handleAddCompany = () => {
    this.setState({ openAddCompanyDialog: true });
  };

  setToolBarData = () => {
    let panel = this.state.tabPanels[this.state.value];
    switch (panel.id) {
      case TAB_PANELS_TYPES.EMPLOYEES:
        this.setState({
          toolBarData: {
            title: "Employees",
            type: TOOL_BAR_BUTTON_TYPES.EMPLOYEE,
            callBack: this.onAddEmployeesCalled,
            additionalToolBarData: {
              title: "Import",
              action: this.onImportCalled,
              icon: <PublishIcon />,
            },
          },
        });
        break;
      case TAB_PANELS_TYPES.EQUIPMENTS:
      case TAB_PANELS_TYPES.INSPECTIONS:
      case TAB_PANELS_TYPES.VISITORS:
      default:
        console.log("Oops something terrible happended");
    }
  };

  getEmployeesCompany = (companyId: String) => {
    let employeeService: EmployeeService = new EmployeeService();
    this.setState({
      isEmployeeLoading: true,
    });
    employeeService.getEmployeesByCompanyId(companyId).then((resp) => {
      this.setState({
        isEmployeeLoading: false,
      });
      if (resp && resp.success && resp.employees) {
        this.setState({
          employees: resp.employees,
        });
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };
  getVisitorsCompany = (companyId: String) => {
    let visitorService: VisitorService = new VisitorService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    visitorService.getVisitorsByCompanyId(companyId).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success && resp.visitors) {
        this.setState({
          visitors: resp.visitors,
        });
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };
  getEquipmentsByCompanyId = (companyId: String) => {
    let equipmentsService: EquipmentsService = new EquipmentsService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    equipmentsService.getEquipmentByCompanyId(companyId).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success && resp.equipments) {
        this.setState({
          equipments: resp.equipments,
        });
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };
  getUniqueLegends = (inspections: any) => {
    let unqiueLegends = Array<any>();
    if (inspections && inspections) {
      inspections.map((inspectionItem: any) => {
        let legends = inspectionItem.legends;
        if (legends) {
          legends.map((inspectionLegendItem: any) => {
            let isAdded = unqiueLegends.filter((legendItem: any) => {
              return (
                legendItem.legendCode === inspectionLegendItem.legendCode &&
                legendItem.legendDefinition ===
                  inspectionLegendItem.legendDefinition &&
                legendItem.inputColor === inspectionLegendItem.inputColor
              );
            });
            if (isAdded.length === 0) {
              unqiueLegends.push(inspectionLegendItem);
            }
            return null;
          });
        }
        return null;
      });
    }
    return unqiueLegends;
  };
  getInspectionsByCompanyId = (companyId: String) => {
    let inspectionService: InspectionService = new InspectionService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    inspectionService.getInspectionsByCompanyId(companyId).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success && resp.inspections) {
        let allLegends = this.getUniqueLegends(resp.inspections);
        this.setState({
          inspections: resp.inspections,
          allLegends: allLegends,
        });
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };

  getCompletedActionedByCompanyId = (companyId: String) => {
    let actionedService: ActionedService = new ActionedService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    actionedService.getCompletedByCompanyId(companyId).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success && resp.completedActions) {
        this.setState({
          completedActions: resp.completedActions,
        });
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };

  getContactTracingByCompanyId = (companyId: String) => {
    let contactTracingService: ContactTracingService =
      new ContactTracingService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    contactTracingService
      .getContactTracingByCompanyId(companyId)
      .then((resp) => {
        EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
        if (resp && resp.success && resp.data) {
          this.setState({
            contacts: resp.data,
          });
        } else if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: "Oops something happened",
          });
        }
      });
  };

  getAssets = () => {
    let company: any = this.state.company;
    let assetsService: AssetsService = new AssetsService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    assetsService.getAssets(company._id).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success && resp.assets) {
        this.setState({
          assets: resp.assets,
        });
      }
    });
  };
  getCompany = (companyId: String) => {
    let displayCompanyData = { show: false, data: null };
    let companiesService: CompaniesService = new CompaniesService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    companiesService.getCompany(companyId).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success && resp.company) {
        this.setState({
          company: resp.company,
          showCompanies: true,
          showToolBarButton: true,
          displayCompanyData: displayCompanyData,
          pageTitle: resp.company.name,
        });
      } else {
        this.setState({
          showCompanies: false,
          showToolBarButton: false,
        });
        if (resp && resp.message) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            show: true,
            type: SNACKBAR_TYPE.ERROR,
            message: resp.message,
          });
        }
      }
    });
  };

  getActionedInspectionByCompany = async (row: any) => {
    let companyId = row.companyId;
    let employeeId = row._id;
    let employeeService: EmployeeService = new EmployeeService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    let resp = await employeeService.getActionedInspectionsByCompany(
      companyId,
      employeeId
    );
    EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
    if (resp && resp.success && resp.actioned) {
      this.setState(
        {
          actionedInspections: resp.actioned,
          showActionedInspectionsDialog: this.state.deleteAll ? false : true,
          actionedInspectionRowSelected: row,
        },
        () => {
          let actionedRow: any = this.state.actionedInspectionRowSelected;
          actionedRow.actionedCount = this.state.actionedInspections.length;
          this.setState({
            actionedInspectionRowSelected: actionedRow,
          });
        }
      );
    } else if (resp.error) {
      EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
        type: SNACKBAR_TYPE.ERROR,
        show: true,
        message: resp.error,
      });
    } else {
      EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
        type: SNACKBAR_TYPE.ERROR,
        show: true,
        message: resp.error,
      });
    }
  };

  handleClose = () => {
    this.setState(
      {
        openAddEmployeesDialog: false,
        openEditEmployeesDialog: false,
        openEmployeeLoginDetailsDialog: false,
        openAddWorkflowInspection: false,
        openViewWorkflowInspectionDialog: false,
        openAddEquipmentsDialog: false,
        openViewInspectionDialog: false,
        openAddInspectionDialog: false,
        openAddVisitorsDialog: false,
        showLicensesDialog: false,
        showActionedInspectionsDialog: false,
        showAuthorizedEquipmentsDialog: false,
        openConfirmationDialog: false,
        showAssignDialog: false,
        showApprovals: false,
        showConfirmationDialog: false,
        showContacts: false,
        openDropZoneDialog: false,
        filesDropZoneFiles: [],
        contactsRowSelected: [],
        openHelpDialog: false,
        editData: {},
        editInspectionData: {},
        editEmployeeData: {},
        editEquipmentData: {},
        editVisitorData: {},
        deletingObject: {},
      },
      () => {
        this.getAssets();
      }
    );
  };
  // user: any, accessRules: any
  handleOnSubmit = (values: any, user: any, accessRules: any) => {
    let panel = this.getPanel(user, accessRules, this.state.value); //this.state.tabPanels[this.state.value];
    if (panel) {
      if (panel.id === TAB_PANELS_TYPES.EMPLOYEES) {
        this.executeAddEmployee(values);
      }
      if (panel.id === TAB_PANELS_TYPES.EQUIPMENTS) {
        this.executeAddEquipments(values);
      }
      if (panel.id === TAB_PANELS_TYPES.INSPECTIONS) {
        this.executeAddInspections(values);
      }
      if (panel.id === TAB_PANELS_TYPES.VISITORS) {
        this.executeAddVisitor(values);
      }
    }
  };
  handleOnEditSubmit = (values: any, user: any, accessRules: any) => {
    let panel = this.getPanel(user, accessRules, this.state.value); //this.state.tabPanels[this.state.value];
    if (panel) {
      if (panel.id === TAB_PANELS_TYPES.EMPLOYEES) {
        this.executeEditEmployee(values);
      }
      if (panel.id === TAB_PANELS_TYPES.EQUIPMENTS) {
        this.executeEditEquipments(values);
      }
      if (panel.id === TAB_PANELS_TYPES.INSPECTIONS) {
        this.executeEditInspections(values);
      }
      if (panel.id === TAB_PANELS_TYPES.VISITORS) {
        this.executeEditVisitor(values);
      }
    }
  };
  renderAddEmployeesDialog = () => {
    return (
      <AddEmployeDialog
        title={"Adding Employee"}
        open={this.state.openAddEmployeesDialog}
        employees={this.state.employees}
        company={this.state.company}
        handleClose={this.handleClose}
        editData={{}}
        handleOnSubmit={this.handleOnSubmit}
      />
    );
  };
  renderAddVisitorsDialog = () => {
    return (
      <AddVisitorDialog
        title={"Adding Visitors"}
        open={this.state.openAddVisitorsDialog}
        visitors={this.state.visitors}
        company={this.state.company}
        handleClose={this.handleClose}
        editData={this.state.editVisitorsData}
        handleOnSubmit={
          this.state.editVisitorsData && this.state.editVisitorsData.fullName
            ? this.handleOnEditSubmit
            : this.handleOnSubmit
        }
      />
    );
  };
  renderEditEmployeesDialog = () => {
    let values = this.state.editEmployeeData;
    values.passportDocument = this.state.editEmployeeData.passportNumber
      ? true
      : false;
    return (
      <AddEmployeDialog
        title={"Adding Employee"}
        open={this.state.openEditEmployeesDialog}
        employees={this.state.employees}
        company={this.state.company}
        handleClose={this.handleClose}
        editData={this.state.editEmployeeData}
        handleOnSubmit={this.handleOnEditSubmit}
      />
    );
  };
  renderAddInspectionDialog = () => {
    return (
      <AddInspectionDialog
        open={this.state.openAddInspectionDialog}
        handleClose={this.handleClose}
        assets={this.state.assets}
        allLegends={this.state.allLegends}
        companyData={this.state.company}
        equipments={this.state.equipments}
        editData={
          this.state.editInspectionData
            ? this.state.editInspectionData
            : undefined
        }
        handleOnSave={
          this.state.editInspectionData &&
          !isEmpty(this.state.editInspectionData)
            ? this.executeEditInspections
            : this.executeAddInspections
        }
      />
    );
  };
  renderSelectInspectionCapureTypeDialog = () => {
    return (
      <SelectInspectionCaptureTypeDialog
        title={"Select Inspection Capture Type"}
        handleClose={() => {
          this.setState({
            openSelectInspectionCaptureType: false,
          });
        }}
        handleOnSubmit={(option: any) => {
          if (option === INSPECTION_CAPTURE_TYPES.NORMAL) {
            this.setState({
              openSelectInspectionCaptureType: false,
              openAddInspectionDialog: true,
            });
          } else {
            this.setState({
              openSelectInspectionCaptureType: false,
              openAddWorkflowInspection: true,
              editInspectionData: {},
            });
          }
        }}
        open={this.state.openSelectInspectionCaptureType}
      />
    );
  };
  renderViewInspectionDialog = () => {
    return (
      <ViewInspectionDialog
        open={this.state.openViewInspectionDialog}
        handleClose={this.handleClose}
        inspectionData={this.state.completedRowSelected}
        company={this.state.company}
      />
    );
  };
  renderViewWorkflowInspectionDialog = () => {
    return (
      <ViewWorkFlowInspectionDialog
        open={this.state.openViewWorkflowInspectionDialog}
        handleClose={this.handleClose}
        inspectionData={this.state.completedRowSelected}
        company={this.state.company}
      />
    );
  };
  renderAddWorkflowInspectionDialog = () => {
    return (
      <AddWorkFlowInspectionDialog
        title={"Add Workflow Inspection"}
        open={this.state.openAddWorkflowInspection}
        handleClose={this.handleClose}
        assets={this.state.assets}
        allLegends={this.state.allLegends}
        company={this.state.company}
        equipments={this.state.equipments}
        editInspectionData={
          this.state.editInspectionData
            ? this.state.editInspectionData
            : undefined
        }
        handleOnSubmit={(values: any) => {
          this.state.editInspectionData &&
          !isEmpty(this.state.editInspectionData)
            ? this.executeEditInspections(values)
            : this.executeAddInspections(values);
        }}
      />
    );
  };
  renderAddEquipmentsDialog = () => {
    return (
      <AddEquipmentsDialog
        title={"Adding Equipments"}
        mode={"ADD"}
        open={this.state.openAddEquipmentsDialog}
        editData={
          this.state.editEquipmentData && !isEmpty(this.state.editEquipmentData)
            ? this.state.editEquipmentData
            : undefined
        }
        handleClose={this.handleClose}
        handleOnSubmit={
          this.state.editEquipmentData &&
          !isEmpty(this.state.editEquipmentData) &&
          this.state.editEquipmentData.number
            ? this.handleOnEditSubmit
            : this.handleOnSubmit
        }
      />
    );
  };
  renderEmployeeLoginDetailsDialog = () => {
    return (
      <GenericDialog
        type={types.DIALOG_INFO}
        title={`Login Details for: ${this.state.recentlyAddedEmployee.fullName}`}
        messages={[
          `Username (Employee Number): ${this.state.recentlyAddedEmployee.employeeNumber} `,
          `Password: ${this.state.recentlyAddedEmployee.password}`,
        ]}
        rightButtonName={"OK"}
        open={this.state.openEmployeeLoginDetailsDialog}
        onCancel={() => this.handleClose()}
        onOk={() => this.handleClose()}
        handleClose={() => this.handleClose()}
      />
    );
  };

  renderApprovalsDialog = () => {
    return (
      <SignedByDialog
        open={this.state.showApprovals}
        dialogTitle={"Signed by"}
        approvalsData={this.state.approvalRowSelected}
        onClose={this.handleClose}
      />
    );
  };

  renderContactsDialog = () => {
    return (
      <ContactsDialog
        open={this.state.showContacts}
        dialogTitle={"Contact With"}
        contactsData={this.state.contactsRowSelected}
        onClose={this.handleClose}
      />
    );
  };

  renderAssignDialog = () => {
    return (
      <AssignDialog
        open={this.state.showAssignDialog}
        dialogTitle={"Assign Inspection"}
        employees={this.state.employees}
        onClose={this.handleClose}
        inspection={this.state.assignRowSelected}
        company={this.state.company}
      />
    );
  };

  renderLicensesDialog = () => {
    let data = this.state.licenseRowSelected.licenseDetails;
    let mData: any = [];
    data.map((item: any) => {
      let issuedDate = getMomentDate(item.issuedDate);
      let expiryDate = getMomentDate(item.expiryDate);
      let authorizedEquipment = item.authorizedEquipment;
      let actionData = [];
      let equipmentData = {
        title: authorizedEquipment.label,
      };
      actionData.push(equipmentData);
      let mItem = {
        icon: <LicenseIcon />,
        option: `License Number: ${item.licenseNumber}`,
        subtitle: `Issued : ${issuedDate.toString()} & Expiry: ${expiryDate.toString()}`,
        action: {
          data: actionData,
          icon: <AuthorisedIcon />,
          type: "more",
        },
      };
      mData.push(mItem);
      return null;
    });
    return (
      <ListItemDialog
        open={this.state.showLicensesDialog}
        dialogTitle={"License Numbers"}
        data={mData}
        onClose={this.handleClose}
      />
    );
  };

  renderAuthorizedEquipmentsDialog = () => {
    let data = this.state.authorizedEquipmentRowSelected.licenseDetails;
    let mData: any = [];
    data.map((item: any) => {
      let authorizedEquipment = item.authorizedEquipment;
      let mItem = {
        icon: <AuthorisedIcon />,
        option: authorizedEquipment.label,
        action: {
          title: `License Number: ${item.licenseNumber}`,
          type: "text",
        },
      };
      mData.push(mItem);
      return null;
    });
    return (
      <ListItemDialog
        open={this.state.showAuthorizedEquipmentsDialog}
        dialogTitle={"Authorized Equipments"}
        data={mData}
        onClose={this.handleClose}
      />
    );
  };
  renderDropZoneDialog = (user: any, accessRules: any) => {
    return (
      <DropzoneDialog
        open={this.state.openDropZoneDialog}
        onSave={(files: any) =>
          this.handleDropZoneSaveFiles(files, user, accessRules)
        }
        showPreviews={true}
        acceptedFiles={[".csv"]}
        maxFileSize={5000000}
        onClose={this.handleClose.bind(this)}
      />
    );
  };
  handleOnDeleteClicked = (item: any) => {
    this.setState({
      showConfirmationDialog: true,
      actionedInspectionDeletionObj: item,
    });
  };
  handleOnDeleteAllClicked = () => {
    this.setState(
      {
        deleteAll: true,
      },
      () => {
        this.handleClose();
        this.handleActionedInspectionConfirmedDeleteAll();
      }
    );
  };
  renderDeleteAction = (item: any) => {
    let { classes } = this.props;
    return (
      <IconButton
        aria-label="delete"
        className={classes.margin}
        size="small"
        onClick={() => this.handleOnDeleteClicked(item)}
      >
        <DeleteIcon />
      </IconButton>
    );
  };
  renderActionedInspectionsDialog = () => {
    let mData: any = [];
    this.state.actionedInspections.map((item: any) => {
      let completionDate = getMomentDate(item.assign.completionDate);
      let mItem = {
        icon: <LicenseIcon />,
        option: `${item.inspection.name}`,
        subtitle: `${
          item.assign.assignedTo.fullName
        } / Completion Date : ${completionDate.toString()}`,
        action: {
          type: "delete",
          renderIconAction: this.renderDeleteAction(item),
        },
      };
      mData.push(mItem);
      return null;
    });
    return (
      <ListItemDialog
        open={this.state.showActionedInspectionsDialog}
        dialogTitle={"Actioned Inspections"}
        data={mData}
        renderDialog={this.renderActionedInspectionDeleteConfirmationDialog()}
        tickAll={true}
        handleOnDeleteAllClicked={this.handleOnDeleteAllClicked}
        onClose={this.handleClose}
      />
    );
  };

  handleConfirmedDelete = () => {
    let deletingObject = this.state.deletingObject;
    if (!deletingObject || !deletingObject.row) {
      return;
    }
    switch (deletingObject.tabType) {
      case TAB_PANELS_TYPES.EMPLOYEES:
        return this.onDeleteEmployeesCalled(deletingObject.row);
      case TAB_PANELS_TYPES.INSPECTIONS:
        return this.onDeleteInspectionsCalled(deletingObject.row);
      case TAB_PANELS_TYPES.EQUIPMENTS:
        return this.onDeleteEquipmentsCalled(deletingObject.row);
      case TAB_PANELS_TYPES.COMPLETED:
        return this.onDeleteCompletedCalled(deletingObject.row);
      case TAB_PANELS_TYPES.VISITORS:
        return this.onDeleteVisitorCalled(deletingObject.row);
      default: {
        return null;
      }
    }
  };

  handleDropZoneSaveFiles = (files: any, user: any, accessRules: any) => {
    const params = this.props.location.state;
    let panel = this.getPanel(user, accessRules, this.state.value); //this.state.tabPanels[this.state.value];
    this.setState(
      {
        filesDropZoneFiles: files,
        openDropZoneDialog: false,
      },
      () => {
        var reader = new FileReader();
        reader.addEventListener("loadend", (event: any) => {
          if (panel.id === TAB_PANELS_TYPES.EMPLOYEES) {
            let employeeService: EmployeeService = new EmployeeService();
            EventEmitter.dispatch(
              EventEmitter.events.START_LOADING_REQUEST,
              {}
            );
            employeeService
              .importEmployees(params.companyId, event.target.result)
              .then((resp) => {
                EventEmitter.dispatch(
                  EventEmitter.events.STOP_LOADING_REQUEST,
                  {}
                );
                if (resp && resp.success && resp.employees) {
                  this.setState({
                    employees: resp.employees,
                  });
                } else if (resp.error) {
                  EventEmitter.dispatch(
                    EventEmitter.events.SEND_SNACK_MESSAGE,
                    {
                      type: SNACKBAR_TYPE.ERROR,
                      show: true,
                      message: resp.error,
                    }
                  );
                } else {
                  EventEmitter.dispatch(
                    EventEmitter.events.SEND_SNACK_MESSAGE,
                    {
                      type: SNACKBAR_TYPE.ERROR,
                      show: true,
                      message: resp.error,
                    }
                  );
                }
              });
          }
          if (panel.id === TAB_PANELS_TYPES.COMPLETED) {
            let actionedService: ActionedService = new ActionedService();
            EventEmitter.dispatch(
              EventEmitter.events.START_LOADING_REQUEST,
              {}
            );
            actionedService
              .importInspections(params.companyId, event.target.result)
              .then((resp) => {
                EventEmitter.dispatch(
                  EventEmitter.events.STOP_LOADING_REQUEST,
                  {}
                );
                if (resp && resp.success && resp.inspections) {
                  this.setState({
                    completedActions: resp.inspections,
                  });
                } else if (resp.error) {
                  EventEmitter.dispatch(
                    EventEmitter.events.SEND_SNACK_MESSAGE,
                    {
                      type: SNACKBAR_TYPE.ERROR,
                      show: true,
                      message: resp.error,
                    }
                  );
                } else {
                  EventEmitter.dispatch(
                    EventEmitter.events.SEND_SNACK_MESSAGE,
                    {
                      type: SNACKBAR_TYPE.ERROR,
                      show: true,
                      message: resp.error,
                    }
                  );
                }
              });
          }
        });
        reader.readAsText(this.state.filesDropZoneFiles[0]);
      }
    );
  };

  handleActionedInspectionConfirmedDelete = () => {
    let deletingObject = this.state.actionedInspectionDeletionObj;
    if (!deletingObject) {
      return;
    }
    let resp = this.state.actionedInspections.filter((item: any) => {
      return item._id === deletingObject._id;
    });
    if (resp.length > 0) {
      let item: any = resp[0];
      let actionedService: ActionedService = new ActionedService();
      EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
      actionedService
        .deleteActionedInspection(item.companyId, item._id)
        .then((resp) => {
          EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
          if (resp && resp.success) {
            this.setState(
              {
                showConfirmationDialog: false,
              },
              async () => {
                await this.getActionedInspectionByCompany(
                  this.state.actionedInspectionRowSelected
                );
              }
            );
          } else if (resp.error) {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          } else {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: "Oops something happened",
            });
          }
        });
    }
  };

  handleActionedInspectionConfirmedDeleteAll = () => {
    let row: any = this.state.actionedInspectionRowSelected;
    let actionedService: ActionedService = new ActionedService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    actionedService
      .deleteAllActionedInspection(row.companyId, row._id)
      .then((resp) => {
        EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
        if (resp && resp.success) {
          this.setState(
            {
              showActionedInspectionsDialog: false,
            },
            async () => {
              await this.getActionedInspectionByCompany(
                this.state.actionedInspectionRowSelected
              );
            }
          );
        } else if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: "Oops something happened",
          });
        }
      });
  };

  renderDeleteConfirmationDialog = () => {
    let deletingObject: any = this.state.deletingObject;
    if (!deletingObject || !deletingObject.row) {
      return;
    }
    let contentMessage = { title: "", message: "" };
    switch (deletingObject.tabType) {
      case TAB_PANELS_TYPES.EMPLOYEES:
        contentMessage = {
          title: `Deleting ${
            deletingObject.row.fullName ? deletingObject.row.fullName : ""
          }`,
          message: "Are you sure want to delete this employee?",
        };
        break;
      case TAB_PANELS_TYPES.INSPECTIONS:
        contentMessage = {
          title: `Deleting ${
            deletingObject.row.name ? deletingObject.row.name : ""
          }`,
          message: "Are you sure want to delete this inspection?",
        };
        break;
      case TAB_PANELS_TYPES.EQUIPMENTS:
        contentMessage = {
          title: `Deleting ${
            deletingObject.row.name ? deletingObject.row.name : ""
          }`,
          message: "Are you sure want to delete this equipment?",
        };
        break;
      case TAB_PANELS_TYPES.VISITORS:
        contentMessage = {
          title: `Deleting ${
            deletingObject.row.fullName ? deletingObject.row.fullName : ""
          }`,
          message: "Are you sure want to delete this visitor?",
        };
        break;
      case TAB_PANELS_TYPES.COMPLETED:
        contentMessage = {
          title: `Deleting ${
            deletingObject.row.assign &&
            deletingObject.row.assign.assignedTo &&
            deletingObject.row.assign.assignedTo.fullName
              ? deletingObject.row.assign.assignedTo.fullName
              : ""
          }'s Inspection`,
          message: "Are you sure want to delete this Inspection?",
        };
        break;
      default: {
        return null;
      }
    }
    return (
      <GenericDialog
        type={types.DIALOG_INFO}
        title={contentMessage.title}
        message={contentMessage.message}
        leftButtonName={"Cancel"}
        rightButtonName={"YES"}
        open={this.state.openConfirmationDialog}
        onCancel={() => this.handleClose()}
        onOk={() => this.handleConfirmedDelete()}
        handleClose={() => this.handleClose()}
      />
    );
  };

  renderActionedInspectionDeleteConfirmationDialog = () => {
    let deletingObject = this.state.actionedInspectionDeletionObj;
    if (!deletingObject) {
      return;
    }
    let contentMessage = {
      title: deletingObject.inspection.name,
      message: "Are you sure you want to delete this Actioned Inspection?",
    };
    return (
      <GenericDialog
        type={types.DIALOG_INFO}
        title={contentMessage.title}
        message={contentMessage.message}
        leftButtonName={"Cancel"}
        rightButtonName={"YES"}
        open={this.state.showConfirmationDialog}
        onCancel={() => this.handleClose()}
        onOk={() => this.handleActionedInspectionConfirmedDelete()}
        handleClose={() => this.handleClose()}
      />
    );
  };

  executeAddEmployee = (values: any) => {
    let employeeModel = values;
    const params = this.props.location.state;
    employeeModel.companyId = params.companyId;
    let employeeService: EmployeeService = new EmployeeService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    employeeService.addEmployee(employeeModel).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        this.setState(
          {
            recentlyAddedEmployee: resp.employee,
            openAddEmployeesDialog: false,
            editData: {},
            openEmployeeLoginDetailsDialog: true,
          },
          () => {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.SUCCESS,
              show: true,
              message: "Employee added Successfully",
            });
            this.getEmployeesCompany(resp.employee.companyId);
          }
        );
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };

  executeAddVisitor = (values: any) => {
    let visitorModel = values;
    const params = this.props.location.state;
    visitorModel.companyId = params.companyId;
    let visitorService: VisitorService = new VisitorService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    visitorService.addVisitor(visitorModel).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        this.setState(
          {
            openAddVisitorsDialog: false,
            editVisitorsData: {},
          },
          () => {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.SUCCESS,
              show: true,
              message: "Visitor added Successfully",
            });
            this.getVisitorsCompany(resp.visitor.companyId);
          }
        );
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };

  executeEditVisitor = (values: any) => {
    let visitorModel = values;
    const params = this.props.location.state;
    visitorModel.companyId = params.companyId;
    let visitorService: VisitorService = new VisitorService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    visitorService.editVisitor(visitorModel).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        this.setState(
          {
            openAddVisitorsDialog: false,
            editVisitorsData: {},
          },
          () => {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.SUCCESS,
              show: true,
              message: "Visitor edited Successfully",
            });
            this.getVisitorsCompany(resp.visitor.companyId);
          }
        );
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };

  executeEditEmployee = (values: any) => {
    let employeeModel = values;
    const params = this.props.location.state;
    employeeModel.companyId = params.companyId;
    let employeeService: EmployeeService = new EmployeeService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    employeeService.editEmployee(employeeModel).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        this.setState(
          {
            openEditEmployeesDialog: false,
            editData: {},
          },
          () => {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.SUCCESS,
              show: true,
              message: "Edited Successfully",
            });
            this.getEmployeesCompany(resp.employee.companyId);
          }
        );
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };

  executeAddInspections = (values: any) => {
    let inspectionModel = values;
    const params = this.props.location.state;
    inspectionModel.companyId = params.companyId;
    let inspectionsService: InspectionService = new InspectionService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    inspectionsService.addInspection(inspectionModel).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success && resp.inspection) {
        this.setState(
          {
            inspection: resp.inspection,
            openAddInspectionDialog: false,
            openAddWorkflowInspection: false,
            editData: {},
          },
          () => {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.SUCCESS,
              show: true,
              message: "Added Successfully",
            });
            this.getInspectionsByCompanyId(resp.inspection.companyId);
          }
        );
      } else {
        if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        }
      }
    });
  };
  executeEditInspections = (values: any) => {
    let inspectionModel = values;
    const params = this.props.location.state;
    inspectionModel.companyId = params.companyId;
    let inspectionsService: InspectionService = new InspectionService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    inspectionsService.editInspection(inspectionModel).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        this.setState(
          {
            inspection: resp.inspection,
            openAddInspectionDialog: false,
            openAddWorkflowInspection: false,
            editData: {},
            editEquipmentData: {},
          },
          () => {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.SUCCESS,
              show: true,
              message: "Edited Successfully",
            });
            this.getInspectionsByCompanyId(params.companyId);
          }
        );
      } else {
        if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        }
        if (resp.message) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.message,
          });
        }
      }
    });
  };
  executeAddEquipments = (values: any) => {
    let equipmentModel = values;
    const params = this.props.location.state;
    equipmentModel.companyId = params.companyId;
    let equipmentService: EquipmentsService = new EquipmentsService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    equipmentService.addEquipment(equipmentModel).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        this.setState(
          {
            openAddEquipmentsDialog: false,
            editData: {},
          },
          () => {
            this.getEquipmentsByCompanyId(resp.equipment.companyId);
          }
        );
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };
  executeEditEquipments = (values: any) => {
    let equipmentModel = values;
    const params = this.props.location.state;
    equipmentModel.companyId = params.companyId;
    let equipmentService: EquipmentsService = new EquipmentsService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    equipmentService.editEquipment(equipmentModel).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        this.setState(
          {
            openAddEquipmentsDialog: false,
            editData: {},
          },
          () => {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.SUCCESS,
              show: true,
              message: "Edited Successfully",
            });
            this.getEquipmentsByCompanyId(resp.equipment.companyId);
          }
        );
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };

  renderTab = (user: any, accessRules: any) => {
    let panels = this.state.tabPanels;
    let permittedPanels = new Array<any>();
    panels.map((mPanel: any) => {
      if (
        HasMutablePermission({
          role: user.role,
          accessRules: accessRules,
          perform: mPanel.perform,
          data: {},
        })
      ) {
        permittedPanels.push(mPanel);
      }
      return null;
    });
    let componentsElements = new Array<any>();
    permittedPanels.map((panel: any, index: any) => {
      componentsElements.push(
        <Tab key={index.toString()} label={panel.title} />
      );
      return null;
    });
    return componentsElements;
  };

  renderTabContent = (user: any, accessRules: any) => {
    let panels = this.state.tabPanels;
    let permittedPanels = new Array<any>();
    panels.map((mPanel: any) => {
      if (
        HasMutablePermission({
          role: user.role,
          accessRules: accessRules,
          perform: mPanel.perform,
          data: {},
        })
      ) {
        permittedPanels.push(mPanel);
      }
      return null;
    });
    let panel = permittedPanels[this.state.value];
    if (panel) {
      if (panel.id === TAB_PANELS_TYPES.EMPLOYEES) {
        return this.renderEmployeeTableComponent(user, accessRules);
      }
      if (panel.id === TAB_PANELS_TYPES.EQUIPMENTS) {
        return this.renderEquipmentTableComponent(user, accessRules);
      }
      if (panel.id === TAB_PANELS_TYPES.INSPECTIONS) {
        return this.renderInspectionsTableComponent(user, accessRules);
      }
      if (panel.id === TAB_PANELS_TYPES.COMPLETED) {
        return this.renderCompletedTableComponent(user, accessRules);
      }
      if (panel.id === TAB_PANELS_TYPES.TRACING) {
        return this.renderContactTracingTableComponent(user, accessRules);
      }
      if (panel.id === TAB_PANELS_TYPES.VISITORS) {
        return this.renderVisitorsTableComponent(user, accessRules);
      }
    }
  };

  getPanel = (user: any, accessRules: any, index: any) => {
    let panels = this.state.tabPanels;
    let permittedPanels = new Array<any>();
    panels.map((mPanel: any) => {
      if (
        HasMutablePermission({
          role: user.role,
          accessRules: accessRules,
          perform: mPanel.perform,
          data: {},
        })
      ) {
        permittedPanels.push(mPanel);
      }
      return null;
    });
    let panel = permittedPanels[index];
    return panel;
  };

  renderEmployeeTableComponent = (user: any, accessRules: any) => {
    return (
      <TableComponent
        tableName={"Employees"}
        columns={EMPLOYEE_COLUMNS}
        data={this.state.employees}
        company={this.state.company}
        createData={this.createEmployeeData}
        uniqueIdentifier={this.createEmployeeUniqueIdentifier}
        deleteAllSelected={this.deleteAllSelectedEmployees}
        deleteAllAction={"company-employees:deleteAll"}
        actions={[
          {
            icon: <EditIcon fontSize="small" />,
            name: TAB_PANELS_TYPES.EMPLOYEES,
            action: this.onEditRow,
            visible: HasMutablePermission({
              role: user.role,
              accessRules: accessRules,
              perform: "company-employees:edit",
              data: {},
            }),
          },
          {
            icon: <DeleteIcon fontSize="small" />,
            name: TAB_PANELS_TYPES.EMPLOYEES,
            action: this.onDeleteRow,
            visible: HasMutablePermission({
              role: user.role,
              accessRules: accessRules,
              perform: "company-employees:delete",
              data: {},
            }),
          },
        ]}
      />
    );
  };
  renderEquipmentTableComponent = (user: any, accessRules: any) => {
    return (
      <TableComponent
        tableName={"Equipments"}
        columns={EQUIPMENT_COLUMNS}
        data={this.state.equipments}
        company={this.state.company}
        deleteAllAction={"company-equipments:deleteAll"}
        createData={createEquipmentsData}
        actions={[
          {
            icon: <EditIcon fontSize="small" />,
            name: TAB_PANELS_TYPES.EQUIPMENTS,
            action: this.onEditRow,
            visible: HasMutablePermission({
              role: user.role,
              accessRules: accessRules,
              perform: "company-equipments:edit",
              data: {},
            }),
          },
          {
            icon: <DeleteIcon fontSize="small" />,
            name: TAB_PANELS_TYPES.EQUIPMENTS,
            action: this.onDeleteRow,
            visible: HasMutablePermission({
              role: user.role,
              accessRules: accessRules,
              perform: "company-equipments:delete",
              data: {},
            }),
          },
        ]}
        uniqueIdentifier={createEquipmentsUniqueIdentifier}
        deleteAllSelected={this.deleteAllSelectedEquipments}
      />
    );
  };
  renderInspectionsTableComponent = (user: any, accessRules: any) => {
    let columns = this.state.company.workflows
      ? INSPECTION_COLUMNS
      : INSPECTION_COLUMNS.filter((obj: any) => {
          return obj.id !== "labels";
        });
    return (
      <TableComponent
        tableName={"Inspections"}
        columns={columns}
        data={this.state.inspections}
        company={this.state.company}
        uniqueIdentifier={this.createInspectionsUniqueIdentifier}
        deleteAllSelected={this.deleteAllSelectedInspections}
        createData={this.createInspectionsData}
        deleteAllAction={"company-inspections:deleteAll"}
        actions={[
          {
            icon: <EditIcon fontSize="small" />,
            name: TAB_PANELS_TYPES.INSPECTIONS,
            action: this.onEditRow,
            visible: HasMutablePermission({
              role: user.role,
              accessRules: accessRules,
              perform: "company-inspections:edit",
              data: {},
            }),
          },
          {
            icon: <DeleteIcon fontSize="small" />,
            name: TAB_PANELS_TYPES.INSPECTIONS,
            action: this.onDeleteRow,
            visible: HasMutablePermission({
              role: user.role,
              accessRules: accessRules,
              perform: "company-employees:delete",
              data: {},
            }),
          },
        ]}
        showDialog={this.handleShowAssign}
      />
    );
  };
  renderAssignedTableComponent = () => {};
  renderCompletedTableComponent = (user: any, accessRules: any) => {
    return (
      <TableComponent
        tableName={"Completed Inspections"}
        columns={COMPLETED_COLUMNS}
        data={this.state.completedActions}
        company={this.state.company}
        uniqueIdentifier={this.createCompletedActionsUniqueIdentifier}
        deleteAllSelected={this.deleteAllSelectedCompletedActionedInspections}
        createData={this.createCompletedActionsData}
        deleteAllAction={"company-completed:deleteAll"}
        actions={[
          {
            icon: <ViewIcon fontSize="small" />,
            name: TAB_PANELS_TYPES.COMPLETED,
            action: this.onViewRow,
            visible: HasMutablePermission({
              role: user.role,
              accessRules: accessRules,
              perform: "company-completed:view",
              data: {},
            }),
          },
          {
            icon: <DeleteIcon fontSize="small" />,
            name: TAB_PANELS_TYPES.COMPLETED,
            action: this.onDeleteRow,
            visible: HasMutablePermission({
              role: user.role,
              accessRules: accessRules,
              perform: "company-completed:delete",
              data: {},
            }),
          },
        ]}
        showDialog={this.handleShowApprovals}
      />
    );
  };
  renderVisitorsTableComponent = (user: any, accessRules: any) => {
    return (
      <TableComponent
        tableName={"Visitors"}
        columns={VISITORS_COLUMNS}
        data={this.state.visitors}
        company={this.state.company}
        uniqueIdentifier={createVisitorsUniqueIdentifier}
        deleteAllSelected={this.deleteAllSelectedVisitors}
        createData={createVisitorsActionsData}
        deleteAllAction={"company-visitors:deleteAll"}
        actions={[
          {
            icon: <EditIcon fontSize="small" />,
            name: TAB_PANELS_TYPES.VISITORS,
            action: this.onEditRow,
            visible: HasMutablePermission({
              role: user.role,
              accessRules: accessRules,
              perform: "company-visitors:edit",
              data: {},
            }),
          },
          {
            icon: <DeleteIcon fontSize="small" />,
            name: TAB_PANELS_TYPES.VISITORS,
            action: this.onDeleteRow,
            visible: HasMutablePermission({
              role: user.role,
              accessRules: accessRules,
              perform: "company-visitors:delete",
              data: {},
            }),
          },
        ]}
        showDialog={this.handleShowApprovals}
      />
    );
  };

  renderContactTracingTableComponent = (user: any, accessRules: any) => {
    return (
      <TableComponent
        tableName={"Contact Tracing"}
        columns={TRACING_COLUMNS}
        data={this.state.contacts}
        company={this.state.company}
        uniqueIdentifier={this.createTracingUniqueIdentifier}
        deleteAllSelected={() => {
          console.log("not implemented");
        }}
        deleteAllAction={"company-tracing:deleteAll"}
        createData={this.createTracingActionsData}
        showDialog={this.handleShowContacts}
      />
    );
  };

  renderFileManagementDialog = () => {
    return (
      <FileManagmentDialog
        company={this.state.company}
        open={this.state.openHelpDialog}
        dialogTitle={"Manage Templates"}
        onClose={this.handleClose}
      />
    );
  };

  onHelperClicked = () => {
    this.setState({
      openHelpDialog: true,
    });
  };

  render() {
    return (
      <React.Fragment>
        <AuthConsumer>
          {({ user, accessRules }) => (
            <div>
              {this.renderDeleteConfirmationDialog()}
              {this.renderActionedInspectionDeleteConfirmationDialog()}
              {this.renderAddEmployeesDialog()}
              {this.renderEditEmployeesDialog()}
              {this.renderEmployeeLoginDetailsDialog()}
              {this.renderAddEquipmentsDialog()}
              {this.renderAddInspectionDialog()}
              {this.renderViewInspectionDialog()}
              {this.renderAddVisitorsDialog()}
              {this.renderActionedInspectionsDialog()}
              {this.renderFileManagementDialog()}
              {this.renderSelectInspectionCapureTypeDialog()}
              {this.renderAddWorkflowInspectionDialog()}
              {this.renderViewWorkflowInspectionDialog()}
              <BaseComponent
                profileData={this.state.profileData}
                pageTitle={this.state.pageTitle}
                toolBarData={this.state.toolBarData}
                onHelperClicked={this.onHelperClicked}
                company={
                  this.props.company ? this.props.company : this.state.company
                }
              >
                <LoadingComponents isLoading={this.state.isEmployeeLoading} />
                <Tabs
                  value={this.state.value}
                  onChange={(event, newValue) => {
                    this.handleChange(event, newValue, user, accessRules);
                  }}
                  aria-label="simple tabs example"
                  TabIndicatorProps={{
                    style: { background: "orange", height: 2 },
                  }}
                >
                  {this.state.tabPanels && this.renderTab(user, accessRules)}
                </Tabs>
                <Divider />
                {this.state.tabPanels.map((item, index) => {
                  return (
                    <TabPanel
                      key={index.toString()}
                      value={this.state.value}
                      index={index}
                    >
                      {this.renderTabContent(user, accessRules)}
                      {this.renderApprovalsDialog()}
                      {this.renderContactsDialog()}
                      {this.renderAssignDialog()}
                      {this.renderLicensesDialog()}
                      {this.renderAuthorizedEquipmentsDialog()}
                      {this.renderDropZoneDialog(user, accessRules)}
                    </TabPanel>
                  );
                })}
              </BaseComponent>
            </div>
          )}
        </AuthConsumer>
      </React.Fragment>
    );
  }
}
CompanyScreen.contextType = AppContext;
export default withStyles(styles)(CompanyScreen);
